module.exports = "https://web-assets-production.autolist.com/_next/static/images/people-2b7e2f414b67995d029a3982bff2e578.jpg";